import { FC } from 'react';
import { Box, Typography } from '@altermaind/web/ui';

type Props = {
  value: string | number;
  width?: string;
};

const SLABadge: FC<Props> = ({ value, width = '50%' }) => {
  return (
    <Box borderRadius='xs' backgroundColor='background/error' width={width} textAlign='center'>
      <Typography variant='p2/light'>{value}</Typography>
    </Box>
  );
};

export { SLABadge };
